import classNames from 'classnames'
import { Outlet, useLocation, useParams } from 'react-router-dom'

import type { ReactElement } from 'react'

import BackNavigation from '~/components/BackNavigation'
import ContentLayout from '~/components/ContentLayout'
import Layout from '~/components/Layouts/Layout'
import ViewTitle from '~/components/ViewTitle'
import useDocumentTitle from '~/hooks/useDocumentTitle'

import './styles.scss'

const ClustersLayout = (): ReactElement => {
  /** Local state */

  const { pathname } = useLocation()

  const { clusterId, storeId } = useParams<{ clusterId: string; storeId: string }>()

  /** Effects */

  useDocumentTitle('Competitors - Clusters')

  /** Render */

  return (
    <Layout className="competitors-clusters-layout">
      <ViewTitle className="competitors-clusters-layout__title-container">
        {!clusterId ? <div className="left" /> : null}
        {clusterId ? (
          <BackNavigation
            title="Back"
            to={
              storeId || pathname.includes('/features-manager')
                ? `/competitors/clusters/${clusterId}`
                : '/competitors/clusters'
            }
          />
        ) : null}
        <div className="competitors-clusters-layout__title-container__title">
          {storeId ? 'Update App Info' : 'Clusters'}
        </div>
        <div className="right" />
      </ViewTitle>
      <ContentLayout
        className={classNames({ 'app-infos-content': !!storeId || pathname.includes('/features-manager') })}
      >
        <Outlet />
      </ContentLayout>
    </Layout>
  )
}

export default ClustersLayout
